{
  "page_title": "Sources",
  "heading": "Sources",
  "load_source_error": "Error loading source",
  "last_updated": "Updated {{updatedAt}}",
  "updated_in_real_time": "This source receives updates in real time",
  "sync_error": "Sync error",
  "entries_date_range": "Showing items from {{startDate}} - {{endDate}}",
  "added_by": "Added by {{name}}",
  "copy_link": {
    "aria": "Copy link",
    "tooltip": "Source URL:",
    "success": "Link copied!"
  },
  "refresh_source": {
    "aria": "Refresh source"
  },
  "delete_source": {
    "confirm_title": "Remove {{title}}?",
    "confirm_message_gcal": "This calendar will be removed from this Agenda Hero schedule. It will remain in your Google Calendar account.",
    "aria": "Remove source from this schedule",
    "submit": "Remove"
  },
  "add_source": "Add source",
  "remove_source": "Remove feed",
  "source_defaults": {
    "ingredients_heading": "Source defaults",
    "preview_heading": "Preview",
    "add_label": "Add label",
    "add_who_label": "Add who label",
    "emoji_picker": {
      "change": "Change",
      "remove": "Remove"
    }
  },
  "add_feed_modal": {
    "heading": "Add source",
    "go_back": "Go back",
    "choose_feed": "Choose feed",
    "feed_url_placeholder": "ICS feed URL",
    "add_source_success_toast": "✨ Source added!",
    "instructions": "Enter the URL to an <1>.ics</1> calendar feed:",
    "or_new": "or new:",
    "add_source": "Add source",
    "invalid": "Enter a valid URL",
    "loading_text": "Importing feed, this may take a while",
    "unknown_error_message": "Error importing feed",
    "source_picker": {
      "google_calendar": {
        "title": "Google Calendar",
        "description": "Import one or more calendars from Google Calendar",
        "coming_soon": "Coming soon!",
        "beta": "Now in beta!"
      },
      "ics_feed": {
        "title": "ICS Feed",
        "description": "Choose this option if you have a URL to an ICS feed"
      },
      "agendahero": {
        "title": "Agenda Hero",
        "description": "Add another Agenda Hero schedule as a source"
      }
    },
    "google_calendar_source": {
      "loading": "Loading calendars...",
      "error": "Error loading calendars",
      "integration_label": "Google account",
      "calendar_label": "Calendar",
      "calendar_select_placeholder": "Select calendar",
      "submit": "Add",
      "success_toast": "✨ Calendar added!",
      "or": "or"
    }
  },
  "empty_state": {
    "title": "Additional sources",
    "byline": "Bring other schedules, calendar feeds, and Google Calendars into your schedule",
    "get_started": "Get started"
  }
}
